import Container from "@/components/Container/Container"
import Row from "@/components/Row/Row"
import Col from "@/components/Col/Col"
import styles from "./Place.module.scss"
import { useTranslations } from "next-intl"

export default function Place({ item }) {
  const t = useTranslations()
  return (
    <section className={styles.place}>
      <Container>
        <Row>
          <Col cols="12" sm="8">
            <h2
              dangerouslySetInnerHTML={{ __html: t.raw("events.place") }}
            ></h2>
            <p dangerouslySetInnerHTML={{ __html: item.place.description }}></p>
          </Col>
          <Col cols="12" sm="8" className={styles.place__media}>
            {item.place.photos.length && (
              <div className={styles.place__images}>
                {item.place.photos[0].image_web ? (
                  <img
                    src={item.place.photos[0].image_web}
                    alt={`picture of ${item.place.title}`}
                  />
                ) : (
                  <img
                    src={item.place.photos[0].image}
                    alt={`picture of ${item.place.title}`}
                  />
                )}

                {item.place.photos[1] && item.place.photos[1].image_web ? (
                  <img
                    src={item.place.photos[1].image_web}
                    alt={`picture of ${item.place.title}`}
                  />
                ) : (
                  item.place.photos[1] && (
                    <img
                      src={item.place.photos[1].image}
                      alt={`picture of ${item.place.title}`}
                    />
                  )
                )}
                <strong className={styles.place__address}>
                  {item.place.address}
                </strong>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  )
}
